// import React, { useState, useEffect, useRef } from "react"
// import "./styles.scss";

// export default props => {
//   let [ load, setLoad ] = useState(false);
//   let [ marks, setMarks ] = useState([]);
//   let [ activeIndex, setActiveIndex ] = useState("");
//   let [ changeProps, setChangeProps ] = useState(false);
//   const [startPosition, setStartPosition] = useState(0);
//   let ref = useRef();

//   useEffect(() => {
//     if(!load) {
//       // const sliderEl4 = document.querySelector("#range4")

//       // sliderEl4.addEventListener("input", (event) => {
//       //   const tempSliderValue = event.target.value; 
        
//       //   const progress = (tempSliderValue / sliderEl4.max) * 100;
      
//       //   sliderEl4.style.background = `linear-gradient(to right, #f50 ${progress}%, #ccc ${progress}%)`;
//       // })
//       generateMarks();
//       setLoad(true);
//     }
//   }, [load]);

//   const generateMarks = () => {
//     let newMarks = [];
//     props.data && props.data.map((item, index) => { 
//       if((props.minimum && item.replace('%', '') >= props.minimum) && (props.maximum && item.replace('%', '') <= props.maximum)) {
//         newMarks = [...newMarks, item]  
//       }
//     })
//     console.log(newMarks)
//     setMarks(newMarks);
//   }

//   function getClickPosition(e) {
//     let clickX = e.offsetX;
//     let marksHTML = document.getElementsByClassName('radio');
//     let allPositionsMarks = [];
//     for(let i = 0; i<marksHTML.length; i++) {
//       let item = marksHTML[i];
//       let itemWidth = item.offsetWidth;
//       if(i == 0) {
//         itemWidth = 0;
//       } 
//       let leftPositionItem = item.offsetLeft + itemWidth / 2;
//       allPositionsMarks = [...allPositionsMarks, leftPositionItem];
//     }
//     for(let x = 0; x < allPositionsMarks.length; x++) {
//       let currentMark = allPositionsMarks[x];
//       let nextMark = allPositionsMarks[x + 1]
//       if(nextMark) {
//         if(clickX > currentMark && clickX < nextMark) {
//           let left = clickX - currentMark;
//           let right = nextMark - clickX;
//           if(left < right) {
//             props.setFunction(marks[x])
//           }else{
//             props.setFunction(marks[x + 1])
//           }
//         }
//       }else{
//         if(clickX > currentMark) {
//           props.setFunction(marks[x])
//         }
//       }
//     }
//   }

//   useEffect(() => {
//     ref?.current?.addEventListener("mousedown", getClickPosition)

//     return () => {
//       ref?.current?.removeEventListener("mousedown", getClickPosition)
//     }
//   })

//   return (
//     <div class="range radio-range-slider">
//       <div className="mask-clickable" ref={ref} />
//       <div className="range-line" />
//       <div class="sliderticks">
//           {marks && marks.map((item, i) => (
//             <span className={"radio " + (props.active === item ? 'active ' : '') + (props.gtmClass ? props.gtmClass : '')}>{ item }</span>
//           ))}
//         </div>
//     </div>
//   )
// }


import React, { useState, useEffect, useRef } from "react";
import "./styles.scss";

export default function RadioRangeSlider(props) {
  const [marks, setMarks] = useState([]);
  const containerRef = useRef();

  useEffect(() => {
    const min = parseFloat(props.minimum);
    const max = parseFloat(props.maximum);

    if (props.data) {
      const filtered = props.data.filter((item) => {
        const num = parseFloat(item.replace("%", ""));
        return num >= min && num <= max;
      });
      setMarks(filtered);
    }
  }, [props.data, props.minimum, props.maximum]);

  const handleClick = (e) => {
    const container = containerRef.current;
    if (!container) return;

    const radios = container.querySelectorAll(".radio");
    const containerRect = container.getBoundingClientRect();
    const clickX = e.clientX - containerRect.left;

    const positions = Array.from(radios).map((radio) => {
      const rect = radio.getBoundingClientRect();
      return rect.left + rect.width / 2 - containerRect.left;
    });

    let closestIndex = 0;
    let closestDistance = Infinity;

    positions.forEach((pos, index) => {
      const dist = Math.abs(clickX - pos);
      if (dist < closestDistance) {
        closestDistance = dist;
        closestIndex = index;
      }
    });

    if (marks[closestIndex]) {
      props.setFunction(marks[closestIndex]);
    }
  };

  return (
    <div className="range radio-range-slider" ref={containerRef}>
      <div className="mask-clickable" onClick={handleClick}></div>
      <div className="range-line" />
      <div className="sliderticks">
        {marks.map((item, index) => (
          <span
            key={index}
            className={
              "radio " +
              (props.active === item ? "active " : "") +
              (props.gtmClass ? props.gtmClass : "")
            }
            style={{ width: `${100 / marks.length}%` }}
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
